import { designTokens } from '../../design-system/tokens.mjs';

/** Runtime access to the same AA Health Projects values consumed by Tailwind and CSS. */
export const palette = designTokens.colors;

export const projectColorFallback = palette.primary;

export const taskStatusColors = Object.freeze({
  todo: palette.primarySubdued,
  in_progress: palette.info,
  review: palette.warning,
  completed: palette.primary,
});
